import gql from "graphql-tag";

export const GET_TERM_OF_SERVICES = gql`
  query terms_of_services(
    $search_text: String
    $order_by_last_update: order_by
  ) {
    terms_of_services(
      order_by: { last_update: $order_by_last_update }
      where: {
        _or: [
          { name: { _ilike: $search_text } }
          { description: { _ilike: $search_text } }
        ]
      }
    ) {
      id
      name
      description
      parse_description
      created_at
      last_update
      terms_of_services_read_or_accepted {
        is_read
        is_accepted
      }
    }
  }
`;
